import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, ExternalLink } from 'lucide-react';

const NavigationMenu = ({ navigationLinks, darkMode }) => {
  const [isOpen, setIsOpen] = useState(false);

  const activeLinks = navigationLinks?.filter(link => link.active) || [];

  if (activeLinks.length === 0) return null;

  const handleLinkClick = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <motion.button
        onClick={() => setIsOpen(!isOpen)}
        className={`p-1.5 rounded-md transition-all duration-200 ${
          darkMode 
            ? 'text-gray-300 hover:text-white hover:bg-white/10' 
            : 'text-gray-600 hover:text-gray-900 hover:bg-black/10'
        }`}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        title="Navigation Menu"
      >
        {isOpen ? <X size={16} /> : <Menu size={16} />}
      </motion.button>

      <AnimatePresence>
        {isOpen && (
          <>
            {/* Backdrop */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="fixed inset-0 z-40"
              onClick={() => setIsOpen(false)}
            />
            
            {/* Dropdown Menu */}
            <motion.div
              initial={{ opacity: 0, y: -10, scale: 0.95 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: -10, scale: 0.95 }}
              transition={{ duration: 0.2 }}
              className={`absolute right-0 top-full mt-2 w-48 rounded-lg shadow-lg border z-50 ${
                darkMode 
                  ? 'bg-gray-800 border-gray-700' 
                  : 'bg-white border-gray-200'
              }`}
            >
              <div className="py-2">
                {activeLinks.map((link, index) => (
                  <motion.button
                    key={index}
                    onClick={() => handleLinkClick(link.url)}
                    className={`w-full px-4 py-2 text-left transition-colors flex items-center justify-between group ${
                      darkMode 
                        ? 'text-gray-300 hover:bg-gray-700 hover:text-white' 
                        : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'
                    }`}
                    whileHover={{ x: 4 }}
                    transition={{ duration: 0.1 }}
                  >
                    <span>{link.name}</span>
                    <ExternalLink 
                      size={14} 
                      className={`opacity-0 group-hover:opacity-100 transition-opacity ${
                        darkMode ? 'text-gray-400' : 'text-gray-500'
                      }`} 
                    />
                  </motion.button>
                ))}
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
};

export default NavigationMenu; 